<template>
  <div>
    <p class="cm-mg-p-wzd">1.1 {{ $t('pqr.pqr_reception_info') }}</p>
    <hr />
    <div class="row">
      <select-component
        :rowClass="`col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2`"
        :isMultiple="false"
        :labelSelect="`${$t('common_words.status')}: *`"
        :dataOptions="statusOption"
        :requireClass="`required-status`"
        :initialSelection="model.status"
        @onChange="handleChangeSelected"
        modelName="status"
      />
      <select-component
        :rowClass="`col-12 col-sm-6 col-md-3 col-lg-3 col-xl-2`"
        :isMultiple="false"
        :labelSelect="`${$t('common_words.type')}: *`"
        :dataOptions="typeOption"
        :requireClass="`required-type`"
        :initialSelection="model.type"
        @onChange="handleChangeSelected"
        modelName="type"
      />
      <div class="col-12 col-sm-6 col-lg-3 col-xl-3">
        <div class="form-group has-label shadow-sm">
          <label>{{ $t('common_words.date') }}: *</label>
          <el-date-picker
            v-if="renderComponent"
            class="required-reception-date"
            :picker-options="pickerOptions"
            v-model="model.reception_date"
            type="datetime"
            :placeholder="$t('common_words.date_hour_select')"
            @change="handleDateChange"
          >
          </el-date-picker>
        </div>
      </div>
      <select-component
        :rowClass="`col-12 col-sm-6 col-md-5 col-lg-4 col-xl-3`"
        :dataOptions="farms"
        :requireClass="`required-farm-ids`"
        @onChange="handleChangeSelected"
        :labelSelect="`${$t('common_words.farms2')}: *`"
        modelName="farm_ids"
        :initialSelection="model.farm_ids"
      />
      <div class="col-12 col-sm-6 col-md-3 col-lg-2 col-xl-2">
        <div class="form-group has-label shadow-sm">
          <label>{{ $t('common_words.week') }}:</label>
          <el-select
            disabled
            v-model="model.reception_week"
            :placeholder="$t('common_words.week')"
          ></el-select>
        </div>
      </div>
      <select-component
        :rowClass="
          showBusiness
            ? `col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3`
            : `col-12 col-sm-6 col-md-4 col-lg-3 col-xl-3`
        "
        :isMultiple="false"
        :dataOptions="receivingOption"
        :requireClass="`required-receiving-method`"
        @onChange="handleChangeSelected"
        :labelSelect="`${$t('common_words.method')}: *`"
        modelName="receiving_method"
        :initialSelection="model.receiving_method"
      />

      <select-component
        :class="
          showBusiness
            ? `col-12 col-sm-6 col-lg-6 col-xl-3`
            : `col-12 col-sm-6 col-lg-3 col-xl-4`
        "
        :isMultiple="false"
        :dataOptions="clients"
        :requireClass="`required-client-id`"
        @onChange="handleChangeSelected"
        :labelSelect="`${$t('pqr.client')}: *`"
        modelName="client_id"
        :initialSelection="model.client_id"
      />
      <div
        :class="
          showBusiness
            ? `col-12 col-sm-6 col-lg-6 col-xl-3`
            : `col-12 col-sm-6 col-lg-4 col-xl-5`
        "
      >
        <div class="form-group">
          <div class="d-flex justify-content-between">
            <label class="text-transform-none">{{
              `Email: ${allRequired ? '*' : ''}`
            }}</label>
            <el-checkbox
              class="justify-content-right"
              v-model="model.send_user_notification"
              :disabled="!model.email"
              name="send_notifications"
              >{{ $t('pqr.send_notifications') }}</el-checkbox
            >
          </div>
          <fg-input
            type="text"
            v-model="model.email"
            name="common_words.email"
            v-validate="allRequired ? 'required|email' : 'email'"
            :error="getError('common_words.email', true)"
          >
          </fg-input>
        </div>
      </div>
      <select-component
        :rowClass="`col-12 col-sm-6 col-lg-6 col-xl-3`"
        :isMultiple="false"
        :dataOptions="businesses"
        :requireClass="`required-business-id`"
        @onChange="handleChangeSelected"
        :labelSelect="`${$t('common_words.company')}: *`"
        modelName="business_id"
        :initialSelection="model.business_id"
        v-if="showBusiness"
      />
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util.js';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinForm from 'src/mixins/forms/mixin-form';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import i18n from 'src/i18n';

export default {
  data() {
    return {
      allRequired: false,
      showBusiness: false,
      businesses: [],
      farms: [],
      clients: [],
      model: {
        status: 'abierto',
        type: null,
        client_id: null,
        clientSelected: null,
        farm_ids: [],
        farmsSelected: [],
        email: null,
        send_user_notification: false,
        reception_date: null,
        reception_week: null,
        receiving_method: null,
        business_id: null,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },

  computed: {
    receivingOption() {
      return [
        { id: 'plataforma digital', name: i18n.t('pqr.digital_platform') },
        { id: 'whatsapp', name: i18n.t('pqr.whatsapp') },
        { id: 'email', name: i18n.t('common_words.email') },
        { id: 'documento fisico', name: i18n.t('pqr.physical_document') },
        { id: 'telefono', name: i18n.t('common_words.phone') },
      ];
    },
    typeOption() {
      return [
        { id: 'peticion', name: i18n.t('pqr.petition') },
        { id: 'queja', name: i18n.t('pqr.complaint') },
        { id: 'reclamo', name: i18n.t('pqr.formal_claim') },
      ];
    },
    statusOption() {
      return [
        { id: 'abierto', name: i18n.t('pqr.open') },
        { id: 'en proceso', name: i18n.t('pqr.in_review') },
        { id: 'cerrado', name: i18n.t('pqr.closed') },
      ];
    },
  },

  mixins: [MixinPermissions, MixinForm, mixinMasters],
  watch: {
    '$i18n.locale': 'forceRerender',
  },

  methods: {
    handleChangeSelected(data) {
      this.$set(this.model, data.name, data.selects);
      if (data.name === 'status') {
        this.$emit('setStatus', data.selects);
        if (data.selects === 'cerrado') {
          this.allRequired = true;
          this.$emit('setAllRequired');
        } else if (data.selects !== 'cerrado') {
          this.$emit('setAllNoRequired');
        }
      } else if (data.name === 'farm_ids') {
        if (isset(this.model.reception_date) && isset(this.model.farm_ids)) {
          this.calculateWeek(this.model.reception_date, data.selects);
        }
      }
    },

    handleDateChange(value) {
      if (isset(this.model.farm_ids)) {
        this.calculateWeek(value, this.model.farm_ids);
      }
    },

    calculateWeek(reception_date, farm_ids) {
      if (reception_date && farm_ids && Array.isArray(farm_ids)) {
        const formattedDate = moment(reception_date).format('YYYY-MM-DD');

        let data = {
          route: 'pqrs/pqrs/calculateWeekFromDate',
          date: formattedDate,
          farm_ids: farm_ids,
        };

        Axios.postMasters(data)
          .then((response) => {
            if (response.data.data.isGregorianCalendar) {
              this.model.farmsSelected = this.farms.find((farm) =>
                farm_ids.includes(farm.id)
              );

              SweetAlert.warning(
                `${i18n.t('sweet_alert.common.the_farm')} "${
                  response.data.data.farmsWithoutCalendar
                }" ${i18n.t('sweet_alert.common.no_registered_calendar')}
                ${i18n.t('sweet_alert.common.unvalid_year_calendar_gregorian')}`
              );
            }
            this.model.reception_week = response.data.data.result;
          })
          .catch((error) => {
            this.showMessageErrors(error);
            this.model.reception_weeks = null;
          });
      } else {
        this.model.reception_weeks = null;
      }
    },

    validate() {
      return this.$validator
        .validateAll()
        .then((responseInputs) => {
          this.$emit('on-validated', responseInputs, {
            ...this.model,
            businessSelected: this.model.business_id
              ? this.getNameSelected(this.model.business_id, this.businesses)
              : null,
            farmsSelected: this.model.farm_ids
              ? this.getNameSelected(this.model.farm_ids, this.farms)
              : null,
            clientSelected: this.model.client_id
              ? this.getNameSelected(this.model.client_id, this.clients)
              : null,
          });

          return responseInputs;
        })
        .then((responseSelects) => {
          if (!responseSelects) return responseSelects;
          if (!isset(this.model.type)) {
            return this.validationInputsRequired('type');
          } else if (!isset(this.model.status)) {
            return this.validationInputsRequired('status');
          } else if (!isset(this.model.reception_date)) {
            return this.validationInputsRequired('reception-date');
          } else if (!isset(this.model.farm_ids)) {
            return this.validationInputsRequired('farm-ids');
          } else if (!isset(this.model.receiving_method)) {
            return this.validationInputsRequired('receiving-method');
          } else if (!isset(this.model.client_id)) {
            return this.validationInputsRequired('client-id');
          } else if (!isset(this.model.business_id)) {
            return this.validationInputsRequired('business-id');
          } else return true;
        })
        .then((response) => {
          if (!response) return response;
          if (isset(this.model.reception_week)) {
            return true;
          } else {
            SweetAlert.warning(
              `${i18n.t('sweet_alert.common.the_farm')}"${
                this.model.farmsSelected.name
              }" ${i18n.t('sweet_alert.common.no_registered_calendar')}!`
            );
            return false;
          }
        });
    },
  },

  mounted() {
    this.showHideLoading(true);
    if (this.isCreate()) {
      Promise.all([
        Axios.getMasters('businesses/only'),
        Axios.getMasters('farms/farms/onlyfruit'),
        Axios.getMasters('pqrs/clients'),
      ])
        .then(([businessesResponse, farmsResponse, clientsResponse]) => {
          this.businesses = businessesResponse.data.data;
          this.farms = this.concatAll(farmsResponse.data.data);
          this.clients = clientsResponse.data.data;
          if (this.businesses.length > 1) {
            this.showBusiness = true;
          } else {
            this.model.business_id = this.businesses[0].id;
          }
          this.showHideLoading();
        })
        .catch((error) => {
          this.showMessageErrors(error);
          this.showHideLoading();
        });
    } else this.showHideLoading();
  },

  updated() {
    if (this.businesses && this.businesses.length > 1) {
      this.showBusiness = true;
    } else if (this.businesses && this.businesses.length === 1) {
      this.model.business_id = this.businesses[0].id;
    }
  },
};
</script>
